module.exports = __webpack_public_path__ + "img/logo.04d2f709.svg";